export const fields = [{
	type: "password",
	name: "password",
	label: "Nova senha",
	autoComplete: "password",
	required: true,
	icon: "lock",
	showRequirements: true,
}]
